export default "__VITE_ASSET__CsPGulhs__"